<template>
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="row">
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
          <h1 class="title-pages pt-2">LANÇAMENTOS</h1>
        </div>
        <div class="col-xl-9 col-lg-9 col-md-9 col-sm-12 col-12 text-right">
          <v-btn
            v-if="type == 'list' && permission('write', 'financial_debit')"
            @click="handleNewRecord('spent')"
            class="btn-delete m-1"
            ><i class="fas fa-plus mr-2 text-twenty"></i>LANÇAR DÉBITO</v-btn
          >
          <v-btn
            v-if="type == 'list' && permission('write', 'financial_credit')"
            @click="handleNewRecord('gain')"
            class="btn-add m-1"
            ><i class="fas fa-plus mr-2 text-twenty"></i>LANÇAR CRÉDITO</v-btn
          >
          <v-btn
            v-if="type == 'list' && permission('write', 'financial_transfer')"
            @click="handleNewRecord('transfer')"
            class="btn-primary m-1"
            ><i class="fas fa-plus mr-2 text-twenty"></i>LANÇAR
            TRANSFERÊNCIA</v-btn
          >
        </div>
      </div>

      <List v-if="type == 'list'" />

      <Spent
        v-if="type == 'spent'"
        @success="handleSuccess"
        @cancel="handleCancel"
        finance_launch_bills_to_pay_type="CONTAS_A_PAGAR"
      />
      <Gain
        v-if="type == 'gain'"
        @success="handleSuccess"
        @cancel="handleCancel"
        finance_launch_bills_to_pay_type="CONTAS_A_RECEBER"
      />
      <Transfer
        v-if="type == 'transfer'"
        @success="handleSuccess"
        @cancel="handleCancel"
      />
    </div>
  </div>
</template>

<script>
import List from "./Releases/List";

import Spent from "./Releases/SpentGain";

import Gain from "./Releases/SpentGain";

import Transfer from "./Releases/Transfer";

import routes from "../../routes";

import permission from "../../lib/permission";

export default {
  name: "Releases",
  components: {
    List,
    Spent,
    Gain,
    Transfer,
  },
  data() {
    return {
      type: "list",
      data: [],
      loading: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    permission,
    retrieve() {
      const { launch } = routes.history.current.query;

      if (launch) {
        this.type = launch;
      } else {
        this.type = "list";
      }
    },
    handleNewRecord(type) {
      let { nav, launch } = routes.history.current.query;

      if (type != launch) {
        routes.replace({ query: { nav, launch: type } });
      }

      this.type = type;
    },
    handleSuccess() {
      let { nav } = routes.history.current.query;
      routes.replace({ query: { nav } });
      this.type = "list";
    },
    handleCancel() {
      let { nav } = routes.history.current.query;
      routes.replace({ query: { nav } });
      this.type = "list";
    },
  },
};
</script>
